"use strict";

class VendorPlugins {
    constructor(initALL = true) {
        console.log('Init Vendor plugins module');
        if (initALL) this.init_iCheck_Radios().init_iCheck_CheckBoxes().init_Select2_Selects();
    }

    init_iCheck_Radios() {
        $("input[type=radio]:not(.toggle):not(.no-icheck)").iCheck({radioClass: 'iradio_square-blue'}).on('ifChecked', event => $(event.target).trigger('change'));

        return this;
    }
    init_iCheck_CheckBoxes() {
        $(".checkbox > input[type=checkbox]:not(.no-icheck)").iCheck({checkboxClass: 'icheckbox_square-blue'});

        return this;
    }
    init_Select2_Selects() {
        $("select.no-search").select2(VendorPlugins.select2_noSearch_Options());
        $("select.search")
            .each((index, selectItem) => {
                let tmpMin, tmpMax;
                $(selectItem).find("option").each((index, optionItem) => {
                    let tmpValue = parseInt(optionItem.value);
                    if (tmpValue > tmpMax || tmpMax === undefined)
                        tmpMax = tmpValue;
                    if (tmpValue < tmpValue || tmpMin === undefined)
                        tmpMin = tmpValue;
                });
                $(selectItem).data("max", tmpMax).data("min", tmpMin);
            })
            .select2(VendorPlugins.select2_Search_Options()).on('select2:select', event => {
                let selectValue = $(event.target).val(),
                    maxValue = $(event.target).data("max"),
                    minValue = $(event.target).data("min");
                if(selectValue < minValue) $(event.target).val(minValue).trigger("change");
                if(selectValue > maxValue) $(event.target).val(maxValue).trigger("change");
            });
        $("select.search-no-new-el").select2(VendorPlugins.select2_Search_Options_Without_New_Elements());
        $("select.simple").select2(VendorPlugins.select2_Simple_Options());
        $("select.multiple").select2(VendorPlugins.select2_Multiple_Options());

        return this;
    }

    static select2_noSearch_Options() {
        return {
            minimumResultsForSearch: -1,
            width: "element"
        }
    }
    static select2_Search_Options() {
        return {
            width: "element",
            tags: true
        }
    }
    static select2_Search_Options_Without_New_Elements() {
        return {
            width: "element"
        }
    }
    static select2_Simple_Options() {
        return {
            minimumResultsForSearch: -1,
            width: "260px",
            dropdownAutoWidth: true,
            containerCssClass: "simple_select2",
            dropdownCssClass: "simple_select2_dropdown"
        }
    }
    static select2_Multiple_Options() {
        return {
            // minimumResultsForSearch: -1,
            // width: "260px",

            dropdownAutoWidth: true,
            containerCssClass: "multiple_select2",
            dropdownCssClass: "multiple_select2_dropdown",
            multiple: true,

            placeholder: 'Все',
            closeOnSelect: true
        }
    }

}

export default VendorPlugins;